export function QClipboardBreakList() {
  this.fTopSCNode = null;
  this.fBottomSCNode = null;
}
